import { set } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

type IdResult = [string, (value: string) => void, () => void];

export const useClientCode = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'client';
  const getId = (): string => {
    // const clientCode = searchParams.get(searchParam)?.includes('DEMO') ? 'PD01#DK' : searchParams.get(searchParam);
    const clientCode = searchParams.get(searchParam)?.includes('DEMO') ? 'STA5#DK' : searchParams.get(searchParam);
    if (searchParams.get(searchParam)?.includes('DEMO')) {
      // console.log('this is the client code', clientCode);
      const newSearchParams = new URLSearchParams();
      // newSearchParams.set(searchParam, 'PD01#DK');
      newSearchParams.set(searchParam, 'STA5#DK');
      setSearchParams(newSearchParams);
    }

    return clientCode ?? 'none';
  };

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams();
    // if '#' is in the string, change it to '%23'
    /*   const valueToSet = value.includes("#") ? value.replace("#", "%23") : value; */
    newSearchParams.set(searchParam, value);
    /*     console.log("this is the value", value, valueToSet, newSearchParams); */

    // setSearchParams("client", value.toString());

    /*    newSearchParams.delete("campaignID");
       newSearchParams.delete("subcampaignID");
       setSearchParams(newSearchParams);
   
   
    */
    setSearchParams(newSearchParams);
  };

  const removeId = useCallback((): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  }, [searchParams, searchParam, setSearchParams]);

  return [getId(), setId, removeId];
};

export const useCampaignId = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'campaignID';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    // console.log("SUBCAMPAIGN", param)
    return param;
  };

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    newSearchParams.set(searchParam, value);
    newSearchParams.delete('subcampaignID');
    newSearchParams.delete('childCampaignID');
    newSearchParams.delete('campaignPeriodID');
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

export const useChildCampaignId = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'childCampaignID';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    return param;
  };

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(searchParam, value);
    newSearchParams.delete('subcampaignID');
    newSearchParams.delete('campaignPeriodID');
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

export const useCampaignPeriodId = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'campaignPeriodID';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    return param;
  };

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(searchParam, value);
    newSearchParams.delete('subcampaignID');
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

export const useSubCampaignId = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'subcampaignID';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    return param;
  };

  // console.log("this is the param", searchParam, getId());

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(searchParam, value);
    console.trace('setSub33');
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

export const useTab = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'tab';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    // console.log("this is the param", param);

    return param;
  };

  // console.log("this is the param", searchParam, getId());

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(searchParam, value);
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

// CUSTOM REPORT
export const useCustomReportId = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'customReportID';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    return param;
  };

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());

    newSearchParams.set(searchParam, value);
    newSearchParams.delete('subcampaignID');
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};

// VIDEO PARAMS
export const useVideoParams = (): IdResult => {
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParam = 'videoSource';

  const getId = (): string => {
    const param = searchParams.get(searchParam) ?? 'none';
    // console.log("this is the param", param);

    return param;
  };

  // console.log("this is the param", searchParam, getId());

  const setId = (value: string): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set(searchParam, value);
    setSearchParams(newSearchParams);
  };

  const removeId = (): void => {
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.delete(searchParam);
    setSearchParams(newSearchParams);
  };

  return [getId(), setId, removeId];
};
